module.exports = __webpack_public_path__ + "static/media/Team 37 - Full of Food.2b89fd67.png";